import { ToastContainer, Slide } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
import './notification.scss';

const Notification = () => (
  <ToastContainer
    position="bottom-left"
    autoClose={5000}
    hideProgressBar
    newestOnTop={false}
    closeOnClick
    rtl={false}
    closeButton={false}
    pauseOnFocusLoss
    draggable
    pauseOnHover
    transition={Slide}
  />
);

export default Notification;
